import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite} from "gsap";
import {Layers, RockBottomLayers} from "../../view/RockBottomLayers";
import {RockBottomSymbol} from "../../symbol/RockBottomSymbol";
import {RockBottomSymbolState} from "../../symbol/RockBottomSymbolConfig";

export class IndividualWinView {
    private _layer: StageLayer;

    constructor() {
        this._layer = RockBottomLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    public playAnimation(symbol: RockBottomSymbol): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(symbol.getStateAnimation(RockBottomSymbolState.WIN_TOGGLE));

        return tl;
    }
}